<div id="bulletin" class="py-4 my-3">
  <div class="container">
    <div class="bullettin-card mx-auto">
      <div class="row bullet bg-light">
        <div class="col-5 col-md-4 col-xl-2 bullet-1">
          <h5 class="text-center">Announcement</h5>
          <span></span>
        </div>
        <div class="col-7 col-md-8 col-xl-10 bullet-2">
          <marquee behavior="scroll" direction="left" class="bulletinMarque" onmouseover="this.stop();"
            onmouseout="this.start();">
            1. PG Admissions 2026–27: Registration for Postgraduate First-Year programmes has been extended until 7
            August 2026. Apply Now! &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            2. Academic Session 2026–27: Classes for UG 1st, 3rd & 5th Semester and PG 3rd Semester students will
            commence from 3 August 2026 (Monday). Students must report to the college by 9:00 a.m.
          </marquee>
        </div>
      </div>
    </div>
  </div>
</div>